import React from 'react';
import {
    Home,
    Settings,
    Star,
    PeopleAlt,
    LocalOffer,
    Dashboard,
    NotificationsNone,
    AttachMoney,
    AccountBox,
    ExitToApp
} from '@material-ui/icons';

const employeesSidebarRoutes = [
    'INDEX',
    'Distributor',
    'Employees',
    'StoreOwners',
    'StoreChannelPartner',
    'Notifications',
    'TransactionHistory',
    'FlipKartProducts',
    'GiftCardsHistory',
    'GiftCards',
];

const adminSidebarRoutes = [
    'INDEX',
    'ManageCommission',
    'HOME',
    'ManageSiteStatus',
    'GCAccounts',
    'GCCategory',
    'GCSlugs',
    'GCTransactions',
    'InstaOrders',
    'InstaBanners',
    'InstaUsers',
    'InstaTransaction',
    'DailyWalletReport',
    //'TopSellers',
    'Admin',
    'GManager',
    'Employees',
    //'StoreOwners',
    //'Distributor',
    'StoreChannelPartner',
    //'StoreTagMapping',
    //'MappingHistory',
    //'Mapping',
    'WalletCredits',
    'WalletSummary',
    'PartnerWalletManagement',
    'FlipKartProducts',
    'GiftCardsHistory',
    'GiftCards',
    'Fintech',
    'ReferralData',
    'Notifications'
];

const gmanagerSidebarRoutes = [
    'INDEX',
    //'TopSellers',
    //'StoreOwners',
    //'Distributor',
    'StoreChannelPartner',
    //'StoreTagMapping',
    //'MappingHistory',
    //'Mapping',
    'FlipKartProducts',
    'GiftCardsHistory',
    'GiftCards',
    'ReferralData',
    'Notifications'
];

const storecpSidebarRoutes = [
    'INDEX',
    'Notifications',
    'Profile',
    'TransactionHistory',
    'MyDailyWalletReport',
    'FlipKartProducts',
    'FintechProducts',
    'GiftCardsHistory',
    'GiftCards',
    'GCTransactions',
    'TopSellers',
    'Fintech',
    'ReferStore',
];

const storeownersSidebarRoutes = [
    'INDEX',
    'Notifications',
    'Profile',
    'TransactionHistory',
    'MyDailyWalletReport',
    'FlipKartProducts',
    'GiftCardsHistory',
    'GiftCards',
    'GCTransactions',
    'TopSellers',
    'ReferStore'
];

const distributorsSidebarRoutes = [
    'INDEX',
    'Notifications',
    'Profile',
    'TransactionHistory',
    'MyDailyWalletReport',
    'FlipKartProducts',
    'GiftCardsHistory',
    'GiftCards',
    'GCTransactions',
    'TopSellers',
    'ReferStore'
];

const sidebar = {
    INDEX: {
        icon: <Home />,
        name: 'IB Dashboard',
        parent: 'Dashboard'
    },
    ManageCommission: {
        icon: <Settings />,
        name: 'Insta PG Management',
        parent: 'InstaManagement'
    },
    HOME: {
        icon: <Settings />,
        name: 'Carousel Management',
        parent: 'WebappManagement'
    },
    ManageSiteStatus: {
        icon: <Settings />,
        name: 'Web App Status',
        parent: 'WebappManagement'
    },
    ReferralData: {
        icon: <Dashboard />,
        name: 'Referral Data',
        parent: 'WebappManagement'
    },
    Notifications: {
        icon: <NotificationsNone />,
        name: 'Notification Management',
        parent: 'WebappManagement'
    },
    GCAccounts: {
        icon: <Settings />,
        name: 'GC Master Accounts',
        parent: 'GCManagement'
    },
    GCCategory:{
        icon: <Settings />,
        name: 'GC Category',
        parent: 'GCManagement'
    },
    GCSlugs:{
        icon: <Settings />,
        name: 'GC Slugs',
        parent: 'GCManagement'
    },
    GCTransactions:{
        icon: <Settings />,
        name: 'GC Transactions',
        parent: 'GCManagement'
    },
    InstaUsers:{
        icon: <Settings />,
        name: 'Insta Users',
        parent: 'InstaManagement'
    },
    InstaOrders:{
        icon: <Settings />,
        name: 'Insta Orders',
        parent: 'InstaManagement'
    },
    InstaBanners:{
        icon: <Settings />,
        name: 'Insta Banner',
        parent: 'InstaManagement'
    },
    InstaTransaction:{
        icon: <Settings />,
        name: 'Insta Transaction',
        parent: 'InstaManagement'
    },
    DailyWalletReport: {
        icon: <Settings />,
        name: 'Daily Wallet Report',
        parent: 'other'
    },
    WalletCredits: {
        icon: <Star />,
        name: 'Wallet Credits',
        parent: 'WalletManagement'
    },
    Admin: {
        icon: <PeopleAlt />,
        name: 'Admins',
        parent: 'TeamManagement'
    },
    GManager: {
        icon: <PeopleAlt />,
        name: 'General Manager',
        parent: 'TeamManagement'
    },
    Employees: {
        icon: <PeopleAlt />,
        name: 'Employees',
        parent: 'TeamManagement'
    },
    StoreOwners: {
        icon: <PeopleAlt />,
        name: 'Store Owners',
        parent: 'TeamManagement'
    },
    Distributor: {
        icon: <PeopleAlt />,
        name: 'Distributor',
        parent: 'TeamManagement'
    },
    StoreChannelPartner: {
        icon: <PeopleAlt />,
        name: 'Channel Partner',
        parent: 'TeamManagement'
    },
    StoreTagMapping: {
        icon: <LocalOffer />,
        name: 'Storetag Assignment',
        parent: 'other'
    },
    MappingHistory: {
        icon: <LocalOffer />,
        name: 'Storetag Lifecycle',
        parent: 'other'
    },
    Mapping: {
        icon: <LocalOffer />,
        name: 'Storetag Monthly Summary',
        parent: 'other'
    },
    WalletSummary: {
        icon: <LocalOffer />,
        name: 'Wallet Summary',
        parent: 'WalletManagement'
    },
    PartnerWalletManagement: {
        icon: <LocalOffer />,
        name: 'Partner Wallet Management',
        parent: 'WalletManagement'
    },
    FlipKartProducts: {
        icon: <LocalOffer />,
        name: 'Flipkart',
        parent: 'other'
    },
    Fintech: {
        icon: <LocalOffer />,
        name: 'Fintech'
    },
    FintechProducts: {
        icon: <LocalOffer />,
        name: 'Fintech Products'
    },
    GiftCardsHistory: {
        icon: <LocalOffer />,
        name: 'My Gift Cards',
        parent: 'other'
    },
    GiftCards: {
        icon: <LocalOffer />,
        name: 'Buy Gift Cards',
        parent: 'other'
    },
    ReferStore: {
        icon: <PeopleAlt />,
        name: 'Refer a Store',
        parent: 'other'
    },
    MyDailyWalletReport: {
        icon: <AttachMoney />,
        name: 'Daily Wallet Report',
        parent: 'WalletManagement'
    },
    TransactionHistory: {
        icon: <AttachMoney />,
        name: 'Transaction History',
        parent: 'other'
    },
    Profile: {
        icon: <AccountBox />,
        name: 'Profile',
        parent: 'other'
    }
};

export {
    adminSidebarRoutes,
    gmanagerSidebarRoutes,
    employeesSidebarRoutes,
    distributorsSidebarRoutes,
    storecpSidebarRoutes,
    storeownersSidebarRoutes,
    sidebar
    
};
